import { useEffect, useState } from 'react';

import { listDrafts, subscribeToDraftChanges } from '../services/drafts';
import { isTokenValid } from '../utils';

/**
 * How many drafts the signed-in person has in one collection (0 while
 * loading, or on any failure — the count is a door to /drafts, not data
 * anyone relies on). Refetches when a draft is created or deleted anywhere
 * in this tab. Never cached across mounts, so it always answers for the
 * account signed in now.
 */
export default function useDraftCount(collectionId, { enabled = true } = {}) {
	const [count, setCount] = useState(0);
	const [nudge, setNudge] = useState(0);

	useEffect(() => subscribeToDraftChanges(() => setNudge(n => n + 1)), []);

	useEffect(() => {
		if (!enabled || !collectionId || !isTokenValid()) {
			setCount(0);
			return undefined;
		}
		let active = true;
		(async () => {
			try {
				const result = await listDrafts({ collectionId, limit: 1 });
				if (active) setCount(Number(result?.total) || 0);
			} catch {
				if (active) setCount(0);
			}
		})();
		return () => { active = false; };
	}, [collectionId, enabled, nudge]);

	return count;
}
